export default __webpack_public_path__ + "media/zurb/img/legacy/chop/3-03f24f61ea72f0e3c3b6cbf6a051cb5d.png";